import React, { useEffect, useState } from 'react';
import { collectorPhoto } from '../../services/api/collector';
import { useAuth } from '../../contexts/AuthContext';
export function CollectorPhoto({ id, alt }: { id: string; alt: string }) {
  const { user } = useAuth();
  const [photo, setPhoto] = useState<{ owner: number; url: string } | null>(null);
  useEffect(() => {
    let cancelled = false;
    let url: string | undefined;
    if (user)
      void collectorPhoto(id)
        .then((blob) => {
          if (cancelled) return;
          url = URL.createObjectURL(blob);
          setPhoto({ owner: Number(user.id), url });
        })
        .catch(() => setPhoto(null));
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [id, user]);
  return photo && photo.owner === Number(user?.id) ? (
    <figure>
      <img className="w-full aspect-[4/3] object-cover rounded-xl" src={photo.url} alt={alt} />
      <figcaption className="sr-only">Private photo spot</figcaption>
    </figure>
  ) : (
    <div className="w-full aspect-[4/3] rounded-xl bg-zinc-900 flex items-center justify-center text-zinc-500">
      Private photo
    </div>
  );
}
